import React, { Component } from 'react';
import { Carousel } from 'react-bootstrap';

class Slideshow extends Component {
    constructor(props) {
        super(props);
        this.eachSlide = this.eachSlide.bind(this);
    }


    eachSlide(slide, i) {
        if (this.props.links === false) {
            return (
                <div className="home-banner" key={i} id={i}>
                    <img target="_blank" alt={slide.ImagePath} src={`/images/${slide.ImagePath}`} />
                </div>
            );
        }
        return (
            <div className="home-banner" key={i} id={i}>
                <a target="_blank" href={slide.url}><img alt={slide.title} src={slide.image} /></a>
            </div>
        );
    }

    render() {
        let carouselClass = "crown-carousel";
        if (this.props.links === false) {
            carouselClass = "careers-carousel";
        }
        return (
            <div>
                {/* <Carousel className={carouselClass}> */}

                {/* <Carousel.Item key={i} id={i}> */}
                <div className="home-container">
                    {this.props.data.map(this.eachSlide)}
                </div>
                {/* </Carousel.Item>
                </Carousel> */}
            </div>
        );
    }

}

export default Slideshow;